var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 510 510",
    style: {
      enableBackground: "new 0 0 510 510"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB4B86"
    },
    d: "M498.266,107.46C487.511,51.854,440.656,10,384.483,10c48.376,57.862,4.119,96.628,4.119,96.628 l84.193,89.223C492.948,170.426,504.595,140.186,498.266,107.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC3C85"
    },
    d: "M125.522,10C69.35,10,22.494,51.854,11.74,107.46c-6.236,32.245,4.892,62.543,24.886,87.618 l85.17-88.034C121.796,107.044,77.146,67.862,125.522,10z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC9AF4"
    },
    d: "M473.379,218.591c0-62.377-50.62-112.943-113.063-112.943c-48.05,0-89.093,29.945-105.464,72.169 c-16.371-42.225-57.414-72.169-105.464-72.169c-65.546-0.175-112.744,55.707-112.744,121.476h-0.018 C36.626,388.253,254.928,500,254.928,500C256.897,499.706,473.379,392.116,473.379,218.591z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6864F7"
    },
    d: "M121.578,109.115c-50.674,13.13-84.934,61.976-84.934,118.008h-0.018 C36.626,388.253,254.928,500,254.928,500c0.912-0.136,47.826-23.285,97.941-65.332 C225.551,377.386,134.117,254.53,121.578,109.115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M121.796,107.044c0,0-44.65-39.182,3.726-97.044C69.35,10,22.494,51.854,11.74,107.46c-6.236,32.245,4.892,62.543,24.886,87.618"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M388.602,106.628c0,0,44.257-38.766-4.119-96.628c56.173,0,103.028,41.854,113.783,97.46c6.329,32.726-5.318,62.966-25.47,88.391"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#052A75",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M473.379,218.591c0-62.377-50.62-112.943-113.063-112.943c-48.05,0-89.093,29.945-105.464,72.169 c-16.371-42.225-57.414-72.169-105.464-72.169c-65.546-0.175-112.744,55.707-112.744,121.476h-0.018 C36.626,388.253,254.928,500,254.928,500C256.897,499.706,473.379,392.116,473.379,218.591z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.6b2727f7d7becd5392ae45033de22df6.svg";
export { ForwardRef as ReactComponent };